let mybutton = document.getElementById("scrollPill");
let wishlistButton = document.getElementById("pill-wishlist-button");

window.onscroll = function() {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 1100 || document.documentElement.scrollTop > 1100) {
    mybutton.style.visibility = 'visible';

    // Add the class to remove the top position when the scroll pill is visible
    // wishlistButton.classList.add('no-top-position');
  } else {
    mybutton.style.visibility = 'hidden';

    // Remove the class and restore the original position when scroll pill is hidden
    // wishlistButton.classList.remove('no-top-position');
  }
}

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
